import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IGoogleResult } from 'src/app/interfaces/igoogle-result';
import { environment } from '../../../environments/environment';
@Injectable()
export class GoogleReviewsService {
    constructor(private http: HttpClient) {}

    public get = (): Promise<IGoogleResult> => {
        return this.http.get<IGoogleResult>(`${environment.marketingUrl}/googlereviews`)
                        .toPromise()
                        .then(r => r)
                        .catch((error: Response | any) => {
                            return Promise.reject(error);
                        });
    }
}
